const parseNumberFromString = (inputString = '') => {
  if (typeof inputString === 'string') {
    const sanitizedString = inputString.replace(/\./g, '');
    const parsedNumber = parseFloat(sanitizedString.replace(',', '.'));

    return isNaN(parsedNumber) ? null : parsedNumber;
  } else {
    return inputString;
  }
};

export default parseNumberFromString;
